export { default as SafariCookieConsent } from "./SafariCookieConsent";
